import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import BotWelcomeImage from '@/assets/bot-welcome-image.webp'
import { Button, Column, Text } from '@/components/core'
import AvatarCard from '@/components/layout/AvatarCard.tsx'
import { useTestChat } from '@/contexts/TestChatContext'
import { ROUTES } from '@/types/routes.ts'

const ReadyToIceBreaker: React.FC = () => {
  const navigate = useNavigate()
  const { prefetchCredentials } = useTestChat()

  useEffect(() => {
    prefetchCredentials()
  }, [prefetchCredentials])

  return (
    <AvatarCard variant="image" botAvatar={BotWelcomeImage} animate>
      <Column className="h-full flex-1">
        <Column className="flex-1 items-center">
          <Column className="w-full flex-1 items-center space-y-5">
            <Text
              color="600"
              align="center"
              className="max-sm:text-xl sm:text-2xl"
            >
              <Text.Translated
                color="600"
                className="max-sm:text-xl sm:text-2xl"
                translationKey="lets_warm_up_ready_to_icebreak"
              />{' '}
              <Text.Translated
                color="600"
                fontWeight="bold"
                className="max-sm:text-xl sm:text-2xl"
                translationKey="warm_up_ready_to_icebreak"
                align="center"
              />
            </Text>
            <Column className="items-center">
              <Text
                color="600"
                align="center"
                className="max-w-[504px] max-sm:max-w-[280px] max-sm:text-base"
              >
                <Text.Translated
                  color="600"
                  className="inline max-sm:text-base"
                  translationKey="ready_to_start_warmup_ready_to_icebreak"
                />{' '}
                <Text.Translated
                  color="600"
                  fontWeight="bold"
                  className="inline max-sm:text-base"
                  translationKey="warmup_ready_to_icebreak"
                />{' '}
                <Text.Translated
                  color="600"
                  className="inline max-sm:text-base"
                  align="center"
                  translationKey="warmup_description_ready_to_icebreak"
                />
              </Text>
            </Column>
          </Column>
          <Column className="mx-16 w-full max-w-[360px] justify-center">
            <Button.Translated
              onClick={() => navigate(ROUTES.TESTING.ICEBREAKER)}
              translationKey="next_button_ready_to_icebreak"
            />
          </Column>
        </Column>
      </Column>
    </AvatarCard>
  )
}

export default ReadyToIceBreaker
